import { ColorCode } from "../types/colorCodes";
import { selectOption } from "../types/selectOption";


//TODO this might not be used anymore, check and remove if it's not. ~tdepole
export const providerName = 'Pediatric Therapeutic Services, Inc.';
export const providerFederalEin = '23-2983406';
export const providerAddress = '525 Fayette Street';
export const providerCityStateZip = 'Conshohocken, PA 19428';
export const providerPhoneNumber = '610-941-7020';
export const providerFaxNumber = '610-941-7792';
export const bookkeeperName = 'Trease Denney';
export const bookkeeperEmail = 'treasa@pts.com';
export const bookkeeperPhoneNumber = '302-467-3693';
export const ConfirmPendingChanges = "You have made changes that were not saved. Press \"OK\" to ignore these changes or press \"Cancel\" to stay on this page. You can save the changes by pressing \"Save\" at the bottom of the page.";
export const powerBiLink = 'https://app.powerbi.com/Redirect?action=OpenReport&appId=9b39dbb6-9c0f-46b3-b88a-42fe41490d2a&reportObjectId=29befcb8-9d7a-4c68-a9ce-ebcfccdf51b5&ctid=47eede07-0129-40ef-a5d4-9e87787f923d&reportPage=ReportSection75a658f08c5208e7e6ed&pbi_source=appShareLink&portalSessionId=319f9b27-985b-4810-93d1-149a24ce7a50'

// export const maxAllowedSingleEntryMinutes: number = 8 * 60; // 8 hours allowed, times 60 minutes per hour

export enum Role {
  Admin = 'Admin',
  Therapist = 'Therapist',
  Director = 'Director',
  Client = 'Client',
  BillingSpecialist = 'Billing Specialist',
  Accounting = 'Accounting',
  Operations = 'Operations',
  SuperUser = 'Super User',
}

export enum NotificationGroupTypes {
  District = 'District',
  Division = 'Division',
  Role = 'Role',
  School = 'School',
  Discipline = 'Discipline',
}

export enum NotificationGroupTypeIdLookup {
  Division = 1,
  District = 2,
  Role = 3,
  School = 4,
  Discipline = 5
}

export enum RoleIdLookup {
  Admin = 1,
  Therapist = 2,
  Director = 3,
  Client = 4,
  BillingSpecialist = 5,
  Accounting = 6,
  Operations = 7,
  SuperUser = 8
}

export enum TimesheetStatus {
  InProgress = 1,
  Submitted = 2,
  Approved = 3,
  Rejected = 4,
}

export enum TimesheetUnlockStatusLookup {
  Pending = 1,
  Accepted = 2,
  Rejected = 3,
}

export enum InvoiceStatus {
  All = 0,
  Pending = 1,
  Approved = 2,
  Rejected = 3,
}

export const monthsOfYear = [
  { value: 1, name: 'January' },
  { value: 2, name: 'February' },
  { value: 3, name: 'March' },
  { value: 4, name: 'April' },
  { value: 5, name: 'May' },
  { value: 6, name: 'June' },
  { value: 7, name: 'July' },
  { value: 8, name: 'August' },
  { value: 9, name: 'September' },
  { value: 10, name: 'October' },
  { value: 11, name: 'November' },
  { value: 12, name: 'December' },
];

export enum EntryTypes {
  Student = 1,
  NonStudent = 2,
  Group = 3,
}

export enum TaskTypeLookup {
  Consult = 1,
  ReEval = 2,
  Mtss = 3,
  Screen = 4,
  Intervention = 5,
  Direct = 6,
  ClinicalSupervision = 7,
  Eval = 8,
  Other = 9,
  EI = 15,
  Indirect = 10,
  Absence = 17,
  Unavailable = 18,
  Group = 12,
  BillTo = 99 //Virtual type
}

export enum BillToLookup {
  District = 1,
  School = 2
}

export enum TimesheetFlagStatus {
  Generated = 1,
  Approved = 2,
  Rejected = 3,
}

export enum TreatmentRuleTypeLookup {
  Dropdown = 1,
  PlanRequired = 2,
  DatesRequired = 3,
  OtherDisciplines = 4,
}

export enum TreatmentPlanLookup {
  Individual = 1,
  Group = 2,
  Consult = 3
}

export const TreatmentRuleTypeDisplay: { [index: number]: string } = {
  [TreatmentRuleTypeLookup.Dropdown]: 'Available In Treatment Via Dropdown',
  [TreatmentRuleTypeLookup.PlanRequired]: 'Treatment Plan Required',
  [TreatmentRuleTypeLookup.DatesRequired]: 'Treatment Start and End Dates Required',
  [TreatmentRuleTypeLookup.OtherDisciplines]: 'Carryover Treatment Via from other Disciplines',
}

export const ItemsSavedMessagesLookup = {
  Default: 'Items Saved',
  Group: 'Entries have been saved for the group. If you need to enter time for another group you have seen at this school, select the student(s) and enter their time.',
  NonStudent: `Entries saved`,
  Student: `Student {{STUDENT_NAME}}'s time entries have been entered. If you need to enter time for another student you have seen at this school, select the student(s) and enter their time.`
}

export const statusOptions: selectOption[] = [
  { value: 1, label: 'Active' },
  { value: 2, label: 'Inactive' },
  { value: 3, label: 'Archived' }
];

export const paymentScheduleOptions: selectOption[] = [
  { value: 1, label: 'Monthly' },
  { value: 2, label: 'TwiceMonthly' },
  { value: 3, label: 'Archived' }
];

//Calendar Color Codes
export const calendarColorCodes: ColorCode[] = [
  { hexCode: '#E74C3C', label: 'Non-Billable Days' },
  { hexCode: '#F1C40F', label: 'Student Non-Billable Days' },
  { hexCode: '#5FDB6A', label: 'School Year Start End Dates for Teachers/Therapists ' },
  { hexCode: '#26B944', label: 'School Year Start End Dates for Students' },
  { hexCode: '#72A0C1', label: 'ESY Start End Dates for Teachers/Therapists ' },
  { hexCode: '#003366', label: 'ESY Start End Dates for Students' },
  { hexCode: '#2F1050', label: 'Exception Dates (like snow days)' }
];

//Student Statuses
export const studentStatuses: any = {
  Referral: { studentStatusId: 1, name: 'Referral'},
  El: { studentStatusId: 2, name: 'El'},
  OnCaseload: { studentStatusId: 3, name: 'On Caseload'},
};

//Page Options
export const defaultPageSizeOptions = [10, 30, 50, 100, 250, 500, 1000];
export const defaultPageSize = defaultPageSizeOptions[3];
export const therapistPageSizeOptions: number[] = [5, 10, 25, 50, 100, 250, 500, 1000];

//Time Entry Options
export const timeEntryMessageTimeout = 5000;

//Therapists Talent Type with respect to Discipline
export enum TalentType {
  IC = 'IC',
  W2 = 'W-2'
}